import ClientsContainer from "./container/ClientsContainer";
export default ClientsContainer;
